import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import catalog_en from "./en/catalog.json";
import chat_en from "./en/chat.json";
import common_en from "./en/common.json";
import layerConfig_en from "./en/layerConfig.json";
import projectConfig_en from "./en/projectConfig.json";
import dialogs_en from "./en/dialogs.json";
import layerList_en from "./en/layerList.json";
import mapControls_en from "./en/mapControls.json";
import projectPanel_en from "./en/projectPanel.json";
import featureCard_en from "./en/featureCard.json";
import print_en from "./en/print.json";
import style_en from "./en/style.json";
import table_en from "./en/table.json";
import tools_en from "./en/tools.json";
import feedback_en from "./en/feedback.json";
import dateFilter_en from "./en/dateFilter.json";
import layerFilter_en from "./en/layerFilter.json";

import catalog_ru from "./ru/catalog.json";
import chat_ru from "./ru/chat.json";
import common_ru from "./ru/common.json";
import layerConfig_ru from "./ru/layerConfig.json";
import projectConfig_ru from "./ru/projectConfig.json";
import dialogs_ru from "./ru/dialogs.json";
import layerList_ru from "./ru/layerList.json";
import mapControls_ru from "./ru/mapControls.json";
import projectPanel_ru from "./ru/projectPanel.json";
import featureCard_ru from "./ru/featureCard.json";
import print_ru from "./ru/print.json";
import style_ru from "./ru/style.json";
import table_ru from "./ru/table.json";
import tools_ru from "./ru/tools.json";
import feedback_ru from "./ru/feedback.json";
import dateFilter_ru from "./ru/dateFilter.json";
import layerFilter_ru from "./ru/layerFilter.json";

export const DEFAULT_LANGUAGE = "ru";

const resources = {
  en: {
    catalog: catalog_en,
    chat: chat_en,
    common: common_en,
    layerConfig: layerConfig_en,
    projectConfig: projectConfig_en,
    dialogs: dialogs_en,
    layerList: layerList_en,
    mapControls: mapControls_en,
    projectPanel: projectPanel_en,
    featureCard: featureCard_en,
    print: print_en,
    style: style_en,
    table: table_en,
    tools: tools_en,
    feedback: feedback_en,
    dateFilter: dateFilter_en,
    layerFilter: layerFilter_en,
  },
  ru: {
    catalog: catalog_ru,
    chat: chat_ru,
    common: common_ru,
    layerConfig: layerConfig_ru,
    projectConfig: projectConfig_ru,
    dialogs: dialogs_ru,
    layerList: layerList_ru,
    mapControls: mapControls_ru,
    projectPanel: projectPanel_ru,
    featureCard: featureCard_ru,
    print: print_ru,
    style: style_ru,
    table: table_ru,
    tools: tools_ru,
    feedback: feedback_ru,
    dateFilter: dateFilter_ru,
    layerFilter: layerFilter_ru,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    ns: Object.keys(resources[DEFAULT_LANGUAGE]),
    interpolation: {
      escapeValue: false,
    },
    resources,
    supportedLngs: Object.keys(resources),
  });

export { i18n };
